import { Component, OnInit, Input } from '@angular/core';

import { Ledger } from '../../../../models/ledger';

import { ChartOfAccountService } from '../../../../services/accounting/chart-of-account.service';
import { UserService } from '../../../../services/users/user.service';

@Component({
  selector: 'app-ledger-adjustment-form',
  templateUrl: './ledger-adjustment-form.component.html',
  styleUrls: ['./ledger-adjustment-form.component.scss'],
})
export class LedgerAdjustmentFormComponent implements OnInit {
  @Input() ledger: Ledger;

  formOptions: any = {
    chart_of_accounts: [],
  };

  constructor(
    private chartOfAccountService: ChartOfAccountService,
    private userService: UserService) {}

  ngOnInit() {
    if(this.userService.navbarComponent){
      this.userService.navbarComponent.setAccountingMenu();
    }
    this.chartOfAccountService.forFormOptions().then((response_json) => {
      this.formOptions = response_json;
      if (this.formOptions.chart_of_accounts.length > 0 && !this.ledger.editing) {
        this.ledger.chart_of_account_id = this.formOptions.chart_of_accounts[0].value;
        this.ledger.chart_of_account_name = this.formOptions.chart_of_accounts[0].label;
        this.ledger.category = 'credit';
        this.ledger.amount = 0;
        this.ledger.created_at = new Date();
      }
    });
  }

  chartOfAccountChange() {
    for (let chartOfAccount of this.formOptions.chart_of_accounts)
      if (chartOfAccount.value == this.ledger.chart_of_account_id) {
        this.ledger.chart_of_account_name = chartOfAccount.label;
        break;
      }
  }
}
